import { render, staticRenderFns } from "./preview-document-dialog.component.vue?vue&type=template&id=4ea66537"
import script from "./preview-document-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./preview-document-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./preview-document-dialog.component.vue?vue&type=style&index=0&id=4ea66537&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports